module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ep2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("Victoria, mysterious child,")]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("Mix of my blood")]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("Will you turn out as wild?")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("—LOUIS LOUSTALOT, ")]), _c('span', {
    staticClass: "R"
  }, [_vm._v("winter 1996,")])]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("as scrawled on a piece of scrap paper")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef2e52de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph2.vue
// module id = 75
// module chunks = 0